import {NgTemplateOutlet} from '@angular/common';
import {Component, effect, Inject, signal, TemplateRef} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {SafeHtml} from '@angular/platform-browser';
import {AuthDataService} from '@authentication/authentication-data.service';
import {AttestationDialogConfig} from '@services/attestation/attestation.service';
import {OrgService} from '@services/organization/org.service';
import {PDE_EULA_SYM} from '@shared/guards/private-data-enclave-eula.guard';

@Component({
  selector: 'app-attestation',
  templateUrl: './attestation.component.html',
  imports: [MatDialogContent, MatDialogActions, MatButton, MatDialogTitle, NgTemplateOutlet],
  styleUrls: ['./attestation.component.scss'],
})
export class AttestationComponent {
  constructor(
    public dialogRef: MatDialogRef<AttestationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AttestationDialogConfig,
    authData: AuthDataService,
    orgService: OrgService,
  ) {
    this.PDE_EULA_SYM = PDE_EULA_SYM;

    effect(() => {
      if (authData.isUserLoggedIn() && orgService.organizationMap()) {
        this.pde_eula_content.set(orgService.getLandingServiceEula(authData.relevantOrgId()));
      }
    });
  }

  public PDE_EULA_SYM: typeof PDE_EULA_SYM;
  pde_eula_content = signal(<SafeHtml>'');

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  isTemplateRef(message: string | TemplateRef<any> | symbol): message is TemplateRef<any> {
    return typeof message !== 'string' && typeof message !== 'symbol';
  }
}
